module.exports = __webpack_public_path__ + "assets/images/bellingen_property_revf4b563ee.png";